(() => {
      'use strict';

      const root = document.querySelector('[data-tfu-quiz]');
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const form = document.getElementById('tractorQuiz');
      const steps = [...form.querySelectorAll('.step')];
      const totalQuestionSteps = 8;
      const maxStep = 10;
      const storageKey = 'tfu_tractor_quiz_v2';
      const progressFill = document.getElementById('progressFill');
      const progressText = document.getElementById('progressText');
      const progressCount = document.getElementById('progressCount');
      const contextImage = document.getElementById('contextImage');
      const visualKicker = document.getElementById('visualKicker');
      const visualTitle = document.getElementById('visualTitle');
      const visualBody = document.getElementById('visualBody');
      const selectionStatuses = [...form.querySelectorAll('[data-selection-for]')];
      const selectOverlay = document.getElementById('selectOverlay');
      const selectSheetTitle = document.getElementById('selectSheetTitle');
      const selectSheetKicker = selectOverlay.querySelector('.select-sheet-kicker');
      const selectSearchWrap = document.getElementById('selectSearchWrap');
      const selectSearch = document.getElementById('selectSearch');
      const selectOptions = document.getElementById('selectOptions');
      const selectEmpty = document.getElementById('selectEmpty');
      const customSelects = [];
      let activeCustomSelect = null;
      let currentStep = 1;
      let quizStarted = false;
      let previewTracked = false;
      let handlingPopState = false;
      let typeAheadBuffer = '';
      let typeAheadTimer = 0;

      const context = [
        ['Built around your work', 'The right tractor starts with the jobs waiting on you.', 'We will use your property, workload, attachments, and timing to narrow the current inventory before a salesperson calls.', root.dataset.imageMedium],
        ['Your working profile', 'Different operators measure “right-sized” differently.', 'We use your working context to balance comfort, productivity, versatility, and total package fit.', root.dataset.imageSmall],
        ['Property fit', 'Acreage is only the beginning.', 'Slopes, mud, gate width, woods, and buildings can matter as much as the number on the property deed.', root.dataset.imageSmallAlt],
        ['Every answer becomes data', 'Tell us every job the tractor must earn its keep doing.', 'Your selected jobs drive the class score, attachment map, and the exact conversation your salesperson receives.', root.dataset.imageHeavy],
        ['Size for the real load', 'The heaviest lift can change the whole recommendation.', 'Loader capacity, stability, ballast, attachment weight, and lift height all need to work together.', root.dataset.imageHeavy],
        ['Priorities', 'Comfort, control, and the real bottleneck belong in one plan.', 'Your operator preferences and current challenges shape the configuration and the opening conversation.', root.dataset.imageGrapple],
        ['Tools make the tractor useful', 'Match the machine and attachment as one working system.', 'We use your jobs and tool interests together so the package is not missing what you actually need.', root.dataset.imageCutter],
        ['Readiness', 'Current inventory only helps if the timing fits.', 'Your timeline, purchase path, and trade-in status help the salesperson prepare a useful first conversation.', root.dataset.imageCommercial],
        ['Class preview', 'See the direction before sharing contact details.', 'Your class preview is calculated only from the quiz answers you chose.', root.dataset.imageMedium],
        ['Verify the lot', 'One last step unlocks the exact current-model plan.', 'Choose how a specialist should verify inventory and follow up about this request.', root.dataset.imageMedium],
        ['Starting direction', 'A practical shortlist, built from your answers.', 'The final match comes after a human verifies the actual load, terrain, attachment, inventory, and operating conditions.', root.dataset.imageMedium]
      ];

      const inventoryClasses = {
        small: {
          label: '24–25 HP sub-compact / small-property tractor',
          price: '$15,766',
          models: 'TYM T254 / T2025P; Kioti CS2510H / CX2510H',
          image: root.dataset.imageSmall,
          reason: 'Your answers point to lighter property maintenance, tighter access, and a package where maneuverability and ease of operation matter most.'
        },
        medium: {
          label: '35 HP compact tractor',
          price: '$24,557',
          models: 'TYM T3035R / T3035H / T3035 Cab; Kioti CK3520H / CK4020SEH',
          image: root.dataset.imageMedium,
          reason: 'Your mix of acreage and jobs calls for more implement and loader capability without jumping straight to a larger-frame tractor.'
        },
        heavy: {
          label: '48–55 HP compact / utility tractor',
          price: '$32,900',
          models: 'TYM T474 / T494 / 4820 / 5520; Kioti DK4720SEH / NS5310H',
          image: root.dataset.imageHeavy,
          reason: 'Your workload points toward heavier loader work, larger implements, agricultural chores, land clearing, or faster repeat work cycles.'
        },
        commercial: {
          label: '66–90 HP utility tractor',
          price: '$38,857',
          models: 'TYM T5075 Cab; Kioti RX6620 / HX9010 Cab',
          image: root.dataset.imageCommercial,
          reason: 'Your acreage, heaviest work, larger-implement needs, and output priorities suggest starting with the largest current utility-class listing.'
        }
      };

      const entryJobLabels = {
        property: 'Mow, maintain, and move things',
        homestead: 'Build a working homestead',
        livestock: 'Handle hay, feed, and pasture',
        land: 'Clear, grade, and reclaim land',
        farm: 'Run a small or working farm',
        contractor: 'Take paid work from job to job'
      };
      const allowedEntrySources = new Set(['inventory_card', 'job_match', 'homepage', 'site_header', 'site_footer']);
      const allowedEntryCtas = new Set(['match_class', 'confirm_exact_match', 'hero', 'education', 'inventory_empty', 'match_standard', 'attachments', 'faq', 'final', 'mobile_sticky', 'desktop_header', 'mobile_header', 'mobile_menu', 'footer']);
      const allowedEntryClasses = new Set(Object.keys(inventoryClasses));
      const allowedEntryModels = new Set(JSON.parse(root.dataset.allowedModels || '[]'));

      function readEntryContext() {
        const params = new URLSearchParams(window.location.search);
        const source = params.get('entry_source') || '';
        const job = params.get('entry_job') || '';
        const tractorClass = params.get('entry_class') || '';
        const cta = params.get('entry_cta') || '';
        const rawModel = params.get('entry_model') || '';
        const sanitizedModel = rawModel.replace(/[^a-z0-9 .-]/gi, '').slice(0, 40);

        return {
          source: allowedEntrySources.has(source) ? source : '',
          cta: allowedEntryCtas.has(cta) ? cta : '',
          landingJob: Object.hasOwn(entryJobLabels, job) ? job : '',
          tractorClass: allowedEntryClasses.has(tractorClass) ? tractorClass : '',
          model: allowedEntryModels.has(sanitizedModel) ? sanitizedModel : ''
        };
      }

      const state = {
        quizVersion: 'tfu-qualification-v1',
        source: 'shopify-native-quiz',
        entryContext: readEntryContext(),
        answers: {},
        derived: {}
      };

      const choiceIconMap = {
        'profile-home': 'home', 'profile-homestead': 'sprout', 'profile-farm': 'livestock', 'profile-contract': 'briefcase', 'profile-mixed': 'compass',
        'terrain-flat': 'field', 'terrain-roll': 'hills', 'terrain-tight': 'width', 'terrain-wet': 'water', 'terrain-steep': 'mountain',
        'job-mow': 'field', 'job-finish': 'home', 'job-loader': 'material', 'job-grade': 'road', 'job-garden': 'sprout',
        'job-clearing': 'logs', 'job-livestock': 'livestock', 'job-post': 'auger', 'job-pallet': 'pallet', 'job-commercial': 'briefcase',
        'load-light': 'light', 'load-mid': 'material', 'load-pallet': 'pallet', 'load-bale': 'bale', 'load-log': 'logs', 'load-unsure': 'question',
        'pain-manual': 'strength', 'pain-time': 'clock', 'pain-rent': 'key', 'pain-small': 'gauge', 'pain-unreliable': 'wrench',
        'pain-none': 'compass', 'pain-backlog': 'list', 'pain-confused': 'compass', 'pain-first': 'tractor',
        'op-easy': 'easy', 'op-precise': 'target', 'op-cab': 'cab', 'op-open': 'eye', 'op-tight': 'width', 'op-output': 'power',
        'att-cutter': 'field', 'att-grapple': 'logs', 'att-forks': 'pallet', 'att-tiller': 'sprout', 'att-box': 'road',
        'att-finish': 'home', 'att-bale': 'bale', 'att-auger': 'auger', 'att-rake': 'rake', 'att-chipper': 'logs', 'att-unsure': 'recommend',
        'time-now': 'power', 'time-30': 'clock', 'time-90': 'calendar', 'time-6': 'calendar', 'time-research': 'compass'
      };

      function hydrateChoiceIcons() {
        form.querySelectorAll('.card-grid .option').forEach(option => {
          const input = option.querySelector('input');
          const placeholder = option.querySelector('.choice-icon');
          const iconName = choiceIconMap[input?.id];
          if (!placeholder || !iconName) return;
          const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
          icon.setAttribute('class', 'choice-icon');
          icon.setAttribute('aria-hidden', 'true');
          icon.setAttribute('viewBox', '0 0 24 24');
          use.setAttribute('href', `#icon-${iconName}`);
          icon.append(use);
          placeholder.replaceWith(icon);
        });
      }

      window.dataLayer = window.dataLayer || [];

      function trackEvent(event, details = {}) {
        const entryDetails = Object.fromEntries(Object.entries({
          entry_source: state.entryContext.source,
          entry_cta: state.entryContext.cta,
          entry_job: state.entryContext.landingJob,
          entry_class: state.entryContext.tractorClass,
          entry_model: state.entryContext.model
        }).filter(([, value]) => Boolean(value)));
        const safePayload = { event, quiz_version: state.quizVersion, ...entryDetails, ...details };
        window.dataLayer.push(safePayload);
        window.dispatchEvent(new CustomEvent('tfu:quiz', { detail: safePayload }));
      }

      function values(name) {
        return [...form.querySelectorAll(`[name="${name}"]:checked`)].map(input => input.value);
      }

      function value(name) {
        const field = form.elements[name];
        if (!field) return '';
        if (field instanceof RadioNodeList) return field.value;
        if (field.type === 'checkbox') return field.checked;
        return field.value.trim ? field.value.trim() : field.value;
      }

      function syncAnswers() {
        state.answers = {
          profile: value('profile'),
          acreage: value('acreage'),
          state: value('state'),
          terrain: values('terrain'),
          jobs: values('jobs'),
          load: value('load'),
          pains: values('pains'),
          operatorPriorities: values('operator'),
          attachmentsRequested: values('attachments'),
          timeline: value('timeline'),
          purchasePath: value('purchasePath'),
          tradeIn: value('tradeIn'),
          contact: {
            firstName: value('firstName'),
            lastName: value('lastName'),
            phone: value('phone'),
            email: value('email'),
            preferredMethod: value('contactMethod'),
            zip: value('zip')
          },
          notes: value('notes'),
          contactConsent: Boolean(form.elements.consent?.checked)
        };
      }

      function setChoiceValues(name, selectedValues) {
        const selected = new Set(Array.isArray(selectedValues) ? selectedValues : [selectedValues]);
        form.querySelectorAll(`[name="${name}"]`).forEach(field => {
          field.checked = selected.has(field.value);
        });
      }

      function applyStoredAnswers(answers) {
        if (!answers || typeof answers !== 'object') return;
        setChoiceValues('profile', answers.profile || '');
        setChoiceValues('terrain', answers.terrain || []);
        setChoiceValues('jobs', answers.jobs || []);
        setChoiceValues('load', answers.load || '');
        setChoiceValues('pains', answers.pains || []);
        setChoiceValues('operator', answers.operatorPriorities || []);
        setChoiceValues('attachments', answers.attachmentsRequested || []);
        setChoiceValues('timeline', answers.timeline || '');
        const simpleFields = {
          acreage: answers.acreage,
          state: answers.state,
          purchasePath: answers.purchasePath,
          tradeIn: answers.tradeIn,
          contactMethod: answers.contact?.preferredMethod
        };
        Object.entries(simpleFields).forEach(([name, storedValue]) => {
          if (form.elements[name]) form.elements[name].value = typeof storedValue === 'string' ? storedValue : '';
        });
        if (form.elements.consent) form.elements.consent.checked = false;
        syncAnswers();
      }

      function sessionAnswers() {
        return {
          ...state.answers,
          contact: {
            preferredMethod: state.answers.contact?.preferredMethod || ''
          },
          notes: '',
          contactConsent: false
        };
      }

      function saveSession() {
        syncAnswers();
        try {
          sessionStorage.setItem(storageKey, JSON.stringify({
            quizVersion: state.quizVersion,
            currentStep,
            quizStarted,
            previewTracked,
            answers: sessionAnswers()
          }));
        } catch (error) {
          console.warn('Quiz session could not be saved in this browser tab.', error);
        }
      }

      function restoreSession() {
        try {
          const raw = sessionStorage.getItem(storageKey);
          if (!raw) return null;
          const saved = JSON.parse(raw);
          if (saved?.quizVersion !== state.quizVersion || !saved.answers) return null;
          applyStoredAnswers(saved.answers);
          quizStarted = Boolean(saved.quizStarted || Number(saved.currentStep) > 1);
          previewTracked = Boolean(saved.previewTracked);
          return {
            step: Math.max(1, Math.min(Number(saved.currentStep) || 1, maxStep)),
            answers: saved.answers
          };
        } catch (error) {
          console.warn('Saved quiz session could not be restored.', error);
          return null;
        }
      }

      function clearSession() {
        try {
          sessionStorage.removeItem(storageKey);
        } catch (error) {
          console.warn('Quiz session could not be cleared.', error);
        }
      }

      function updateSelectionStatuses() {
        selectionStatuses.forEach(status => {
          const name = status.dataset.selectionFor;
          const count = values(name).length;
          const total = form.querySelectorAll(`[name="${name}"]`).length;
          status.querySelector('strong').textContent = name === 'jobs'
            ? `${count} of ${total} selected`
            : `${count} selected`;
        });
      }

      function updateCustomSelectTrigger(item) {
        const selected = item.select.selectedOptions[0];
        const hasValue = Boolean(item.select.value);
        item.trigger.querySelector('.select-trigger-value').textContent = hasValue
          ? selected.textContent
          : item.placeholder;
        item.trigger.classList.toggle('has-value', hasValue);
      }

      function renderCustomSelectOptions(query = '') {
        if (!activeCustomSelect) return;
        const normalized = query.trim().toLocaleLowerCase();
        const options = [...activeCustomSelect.select.options]
          .filter(option => option.value)
          .filter(option => !normalized || option.textContent.toLocaleLowerCase().includes(normalized));

        selectOptions.replaceChildren();
        options.forEach(option => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'select-option';
          button.dataset.value = option.value;
          button.setAttribute('role', 'option');
          button.setAttribute('aria-selected', String(option.value === activeCustomSelect.select.value));

          const label = document.createElement('span');
          label.textContent = option.textContent;
          const check = document.createElement('span');
          check.className = 'select-option-check';
          check.setAttribute('aria-hidden', 'true');
          check.textContent = '✓';
          button.append(label, check);
          selectOptions.append(button);
        });
        selectEmpty.hidden = options.length > 0;
      }

      function openCustomSelect(item) {
        if (activeCustomSelect && activeCustomSelect !== item) closeCustomSelect(false);
        activeCustomSelect = item;
        typeAheadBuffer = '';
        window.clearTimeout(typeAheadTimer);
        selectOverlay.dataset.selectFor = item.select.id;
        item.trigger.setAttribute('aria-expanded', 'true');
        selectSheetTitle.textContent = item.sheetTitle;
        selectSheetKicker.textContent = item.searchable ? 'Search or scroll' : 'Choose one';
        selectSearchWrap.hidden = !item.searchable;
        selectSearch.value = '';
        selectSearch.placeholder = item.searchable ? 'Type a state name' : 'Type to search';
        renderCustomSelectOptions();
        item.trigger.insertAdjacentElement('afterend', selectOverlay);
        selectOverlay.hidden = false;

        requestAnimationFrame(() => requestAnimationFrame(() => {
          const focusTarget = item.searchable
            ? selectSearch
            : (selectOptions.querySelector('[aria-selected="true"]') || selectOptions.querySelector('.select-option'));
          focusTarget?.focus({ preventScroll: true });
          focusTarget?.scrollIntoView({ block: 'nearest' });
        }));
      }

      function closeCustomSelect(restoreFocus = true) {
        if (!activeCustomSelect) return;
        const trigger = activeCustomSelect.trigger;
        trigger.setAttribute('aria-expanded', 'false');
        activeCustomSelect = null;
        typeAheadBuffer = '';
        window.clearTimeout(typeAheadTimer);
        selectOverlay.hidden = true;
        delete selectOverlay.dataset.selectFor;
        if (restoreFocus) trigger.focus({ preventScroll: true });
      }

      function refreshCustomSelects() {
        customSelects.forEach(updateCustomSelectTrigger);
      }

      function initCustomSelects() {
        form.querySelectorAll('.field select').forEach(select => {
          const field = select.closest('.field');
          const label = field.querySelector(`label[for="${select.id}"]`);
          const placeholder = select.options[0]?.textContent || 'Choose an option';
          const labelText = label?.textContent.trim() || select.name;
          const searchable = select.id === 'state';
          const sheetTitles = {
            acreage: 'Choose acreage',
            state: 'Search and choose a state',
            purchasePath: 'How do you plan to buy?',
            tradeIn: 'Do you have a trade-in?',
            contactMethod: 'How should we contact you first?'
          };
          const trigger = document.createElement('button');

          select.classList.add('native-select');
          select.tabIndex = -1;
          select.setAttribute('aria-hidden', 'true');
          if (label && !label.id) label.id = `${select.id}Label`;

          trigger.type = 'button';
          trigger.className = 'select-trigger';
          trigger.id = `${select.id}Trigger`;
          trigger.setAttribute('aria-haspopup', 'listbox');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('aria-controls', 'selectOptions');
          if (select.getAttribute('aria-describedby')) trigger.setAttribute('aria-describedby', select.getAttribute('aria-describedby'));
          if (label) trigger.setAttribute('aria-labelledby', `${label.id} ${trigger.id}`);
          trigger.innerHTML = '<span class="select-trigger-value"></span><span class="select-trigger-icon" aria-hidden="true"></span>';
          select.insertAdjacentElement('afterend', trigger);

          const item = { select, trigger, placeholder, labelText, searchable, sheetTitle: sheetTitles[select.id] || `Choose ${labelText}` };
          customSelects.push(item);
          updateCustomSelectTrigger(item);
          trigger.addEventListener('click', () => {
            if (activeCustomSelect === item) closeCustomSelect();
            else openCustomSelect(item);
          });
          trigger.addEventListener('keydown', event => {
            if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) {
              event.preventDefault();
              openCustomSelect(item);
            } else if (event.key === 'Escape' && activeCustomSelect === item) {
              event.preventDefault();
              closeCustomSelect();
            } else if (item.searchable && event.key.length === 1 && !event.metaKey && !event.ctrlKey && !event.altKey) {
              event.preventDefault();
              openCustomSelect(item);
              requestAnimationFrame(() => {
                selectSearch.value = event.key;
                renderCustomSelectOptions(event.key);
                selectSearch.focus();
              });
            }
          });
          select.addEventListener('change', () => updateCustomSelectTrigger(item));
        });

        selectOptions.addEventListener('click', event => {
          const option = event.target.closest('.select-option');
          if (!option || !activeCustomSelect) return;
          activeCustomSelect.select.value = option.dataset.value;
          updateCustomSelectTrigger(activeCustomSelect);
          activeCustomSelect.select.dispatchEvent(new Event('change', { bubbles: true }));
          closeCustomSelect();
        });
        selectOptions.addEventListener('keydown', event => {
          const option = event.target.closest('.select-option');
          if (!option || !activeCustomSelect) return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            option.click();
            return;
          }
          const visibleOptions = [...selectOptions.querySelectorAll('.select-option')];
          const currentIndex = visibleOptions.indexOf(option);
          let targetIndex = currentIndex;
          if (event.key === 'ArrowDown') targetIndex = Math.min(currentIndex + 1, visibleOptions.length - 1);
          else if (event.key === 'ArrowUp') targetIndex = Math.max(currentIndex - 1, 0);
          else if (event.key === 'Home') targetIndex = 0;
          else if (event.key === 'End') targetIndex = visibleOptions.length - 1;
          else if (event.key.length === 1 && !event.metaKey && !event.ctrlKey && !event.altKey) {
            typeAheadBuffer += event.key.toLocaleLowerCase();
            window.clearTimeout(typeAheadTimer);
            typeAheadTimer = window.setTimeout(() => { typeAheadBuffer = ''; }, 650);
            const matchIndex = visibleOptions.findIndex(button => button.textContent.trim().toLocaleLowerCase().startsWith(typeAheadBuffer));
            if (matchIndex >= 0) targetIndex = matchIndex;
          } else {
            return;
          }
          event.preventDefault();
          visibleOptions[targetIndex]?.focus();
          visibleOptions[targetIndex]?.scrollIntoView({ block: 'nearest' });
        });
        selectSearch.addEventListener('input', () => renderCustomSelectOptions(selectSearch.value));
        selectSearch.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            selectOptions.querySelector('.select-option')?.focus();
          }
        });
        selectOverlay.querySelectorAll('[data-select-close]').forEach(button => button.addEventListener('click', () => closeCustomSelect()));
        document.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !activeCustomSelect) return;
          event.preventDefault();
          closeCustomSelect();
        }, true);
        document.addEventListener('click', event => {
          if (!activeCustomSelect) return;
          if (selectOverlay.contains(event.target) || activeCustomSelect.trigger.contains(event.target)) return;
          closeCustomSelect(false);
        });
      }

      function validateStep(index, { focus = true } = {}) {
        const step = steps.find(item => Number(item.dataset.step) === index);
        if (!step) return true;
        const error = step.querySelector('[data-error]');
        let valid = true;
        const invalidTargets = [];

        step.classList.remove('has-error');
        step.querySelectorAll('[aria-invalid="true"]').forEach(field => field.removeAttribute('aria-invalid'));
        step.querySelectorAll('[data-field-error]').forEach(message => { message.hidden = true; });

        step.querySelectorAll('[data-required]').forEach(group => {
          const name = group.dataset.required;
          if (!form.querySelector(`[name="${name}"]:checked`)) {
            valid = false;
            group.querySelectorAll('input').forEach(field => field.setAttribute('aria-invalid', 'true'));
            invalidTargets.push(group.querySelector('input'));
          }
        });

        step.querySelectorAll('[required]').forEach(field => {
          const invalid = field.type === 'checkbox' ? !field.checked : !field.value.trim() || !field.validity.valid;
          const message = step.querySelector(`[data-field-error="${field.name}"]`);
          if (message) message.hidden = !invalid;
          if (invalid) {
            valid = false;
            field.setAttribute('aria-invalid', 'true');
            if (field.matches('select.native-select')) field.nextElementSibling?.setAttribute('aria-invalid', 'true');
            invalidTargets.push(field);
          }
        });

        if (error) error.hidden = valid;
        if (!valid) {
          step.classList.add('has-error');
          const invalidField = invalidTargets.find(Boolean) || step.querySelector('[required]:invalid, [data-required] input');
          const focusTarget = invalidField?.matches('select.native-select') ? invalidField.nextElementSibling : invalidField;
          if (focus) {
            trackEvent('tfu_quiz_validation_error', {
              step_key: ['start', 'profile', 'property', 'jobs', 'load', 'priorities', 'attachments', 'readiness', 'result_preview', 'contact'][index] || 'unknown',
              error_count: [...new Set(invalidTargets.filter(Boolean))].length
            });
            const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
            const fieldRegion = focusTarget?.closest('.field, .consent, .options') || error;
            fieldRegion?.scrollIntoView({ behavior, block: 'center' });
            requestAnimationFrame(() => focusTarget?.focus({ preventScroll: true }));
          }
        }
        return valid;
      }

      function updateProgress() {
        const isComplete = currentStep === 10;
        const isContact = currentStep === 9;
        const label = isComplete ? 'Match complete' : isContact ? 'Verify exact models' : 'Building your match';
        const count = isComplete ? 'Complete' : isContact ? 'Last step' : `Step ${currentStep} of ${totalQuestionSteps} · about 2 minutes`;
        const percentage = (isComplete || isContact) ? 100 : (Math.min(currentStep, totalQuestionSteps) / totalQuestionSteps) * 100;
        progressText.textContent = label;
        progressCount.textContent = count;
        progressFill.style.width = `${percentage}%`;
      }

      function updateContext() {
        const item = context[currentStep];
        visualKicker.textContent = item[0];
        visualTitle.textContent = item[1];
        visualBody.textContent = item[2];
        contextImage.src = item[3];
      }

      function showStep(index, direction = 'forward', options = {}) {
        if (activeCustomSelect) closeCustomSelect(false);
        const previousStep = currentStep;
        currentStep = Math.max(1, Math.min(index, maxStep));
        root.dataset.quizStep = String(currentStep);
        steps.forEach(step => { step.hidden = Number(step.dataset.step) !== currentStep; });
        updateProgress();
        updateContext();
        updateSelectionStatuses();
        const useSmoothScroll = direction === 'forward'
          && !window.matchMedia('(max-width: 620px)').matches
          && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        root.scrollIntoView({ block: 'start', behavior: useSmoothScroll ? 'smooth' : 'auto' });
        const heading = steps.find(step => Number(step.dataset.step) === currentStep)?.querySelector('h1, h2');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          requestAnimationFrame(() => heading.focus({ preventScroll: true }));
        }
        if (options.history !== false) {
          const method = options.replaceHistory || previousStep === currentStep ? 'replaceState' : 'pushState';
          window.history[method]({ tfuQuizStep: currentStep }, '', window.location.href);
        }
        if (options.persist !== false) saveSession();
      }

      function attachmentDirection() {
        const explicit = state.answers.attachmentsRequested.filter(item => !item.startsWith('Not sure'));
        const suggested = [];
        const jobs = state.answers.jobs;
        const map = [
          [['Mow fields or heavy brush'], 'Rotary cutter / bush hog'],
          [['Finish mow lawns'], 'Finish mower'],
          [['Maintain a driveway or grade land'], 'Box blade or scrape blade'],
          [['Till gardens or food plots'], 'Tiller'],
          [['Clear brush, roots, logs, or storm debris'], 'Root grapple or grapple rake'],
          [['Handle livestock, feed, or hay'], 'Bale spear'],
          [['Dig post holes or plant trees'], 'Post-hole auger'],
          [['Lift pallets or load trucks'], 'Pallet forks']
        ];
        map.forEach(([needles, tool]) => { if (needles.some(job => jobs.includes(job))) suggested.push(tool); });
        const combined = [...new Set([...explicit, ...suggested])];
        return combined.length ? combined.join(', ') : 'Loader plus a job-specific implement review';
      }

      function scoreTractorClass(a) {
        const terrain = Array.isArray(a.terrain) ? a.terrain : [];
        const jobs = Array.isArray(a.jobs) ? a.jobs : [];
        const operatorPriorities = Array.isArray(a.operatorPriorities) ? a.operatorPriorities : [];
        const classReasons = [];
        const classOrder = ['small', 'medium', 'heavy', 'commercial'];

        const acreageScores = { 'Under 3 acres': 0, '3–10 acres': 1, '11–25 acres': 2, '26–50 acres': 3, '51–100 acres': 4, 'More than 100 acres': 5 };
        const acreagePoints = acreageScores[a.acreage] || 0;

        let terrainPoints = 0;
        if (terrain.includes('Rolling or uneven ground')) terrainPoints += 1;
        if (terrain.includes('Wet, soft, or muddy ground')) terrainPoints += 1;
        if (terrain.includes('Steep ground')) {
          terrainPoints += 1;
          classReasons.push('steep-ground safety review required');
        }
        if (terrain.includes('Tight gates, woods, or buildings')) {
          classReasons.push('verify gate width, barn clearance, turning radius, and compact configuration');
        }

        const heavyJobs = ['Clear brush, roots, logs, or storm debris', 'Handle livestock, feed, or hay', 'Lift pallets or load trucks', 'Perform paid or commercial work'];
        const jobPointsRaw = jobs.reduce((total, job) => total + (heavyJobs.includes(job) ? 1 : 0.5), 0);
        const jobPoints = Math.min(4, jobPointsRaw);

        let loadPoints = 0;
        let loadFloor = 'small';
        if (a.load === 'Dirt, gravel, manure, or feed') loadPoints = 1;
        if (a.load === 'Pallets or bulk material') {
          loadPoints = 2;
          loadFloor = 'medium';
          classReasons.push('verify pallet weight, lift height, fork setup, ballast, and stability');
        }
        if (a.load === 'Round bales') {
          loadPoints = 3;
          loadFloor = 'heavy';
          classReasons.push('verify bale weight, lift geometry, ballast, and stability');
        }
        if (a.load === 'Logs, roots, or heavy debris') {
          loadPoints = 3;
          loadFloor = 'heavy';
          classReasons.push('verify grapple setup, ballast, hydraulics, and stability');
        }
        if (a.load === 'Not sure yet') {
          classReasons.push('confirm actual maximum load before final model selection');
        }

        const profilePoints = {
          'Farmer or livestock producer': 1,
          'Contractor or commercial operator': 2,
          'A mix of these': 1
        }[a.profile] || 0;
        const outputPoints = operatorPriorities.includes('Maximum output and capacity') ? 1 : 0;
        if (operatorPriorities.includes('Compact size for tight access')) {
          classReasons.push('prioritize a compact configuration without reducing the verified load-capacity floor');
        }

        const score = acreagePoints + terrainPoints + jobPoints + loadPoints + profilePoints + outputPoints;

        let classKey = 'small';
        if (score >= 7) classKey = 'heavy';
        else if (score >= 3) classKey = 'medium';
        if (classOrder.indexOf(classKey) < classOrder.indexOf(loadFloor)) {
          classKey = loadFloor;
          classReasons.push(`heaviest load sets a minimum ${inventoryClasses[loadFloor].label} starting point`);
        }

        const commercialSignals = {
          contractorProfile: a.profile === 'Contractor or commercial operator',
          paidWork: jobs.includes('Perform paid or commercial work'),
          acreageOrOutput: a.acreage === 'More than 100 acres' || outputPoints === 1,
          heavyLoad: ['Pallets or bulk material', 'Round bales', 'Logs, roots, or heavy debris'].includes(a.load)
        };
        const commercialGate = Object.values(commercialSignals).every(Boolean);
        if (commercialGate) classKey = 'commercial';

        const adjacentCommercial = classKey === 'heavy' && (
          score >= 11
          || (commercialSignals.paidWork && outputPoints === 1)
          || a.acreage === 'More than 100 acres'
        );
        const adjacentClass = adjacentCommercial ? 'commercial' : '';
        const adjacentReason = adjacentCommercial
          ? 'Your acreage, duty cycle, or output signals make the 75 HP utility class worth verifying alongside the primary 48–55 HP match. Implement size, lift geometry, transport, and current availability should decide whether moving up is justified.'
          : '';
        if (adjacentCommercial) {
          classReasons.push('compare T5075 Cab only if duty cycle and implement requirements justify moving up');
        }

        return {
          tractorClass: classKey,
          tractorScore: score,
          adjacentClass,
          adjacentModels: adjacentClass ? inventoryClasses[adjacentClass].models : '',
          adjacentReason,
          qualificationFlags: classReasons,
          scoreBreakdown: {
            acreage: acreagePoints,
            terrain: terrainPoints,
            jobsRaw: jobPointsRaw,
            jobsApplied: jobPoints,
            load: loadPoints,
            profile: profilePoints,
            operator: outputPoints,
            total: score,
            loadFloor,
            commercialGate,
            commercialSignals
          }
        };
      }

      function calculateRecommendation() {
        const a = state.answers;
        const recommendation = scoreTractorClass(a);

        let leadScore = 0;
        if (['As soon as the right package is available', 'Within 30 days'].includes(a.timeline)) leadScore += 5;
        else if (a.timeline === 'Within 1–3 months') leadScore += 3;
        else if (a.timeline === 'Within 3–6 months') leadScore += 1;
        if (a.purchasePath && a.purchasePath !== 'Not sure yet') leadScore += 2;
        if (a.tradeIn === 'Yes' || a.tradeIn === 'Possibly') leadScore += 1;
        if (a.jobs.length >= 3) leadScore += 1;
        if (a.pains.length >= 2) leadScore += 1;
        if (a.profile === 'Contractor or commercial operator') leadScore += 1;

        const priority = leadScore >= 8 ? 'Hot — contact first' : leadScore >= 5 ? 'Warm — contact within 24 hours' : 'Nurture — helpful follow-up';
        const eastCoast = !['Other / not listed'].includes(a.state);

        state.derived = {
          ...recommendation,
          leadScore,
          leadPriority: priority,
          attachmentDirection: attachmentDirection(),
          currentModels: inventoryClasses[recommendation.tractorClass].models,
          serviceAreaFlag: eastCoast ? 'Listed East Coast state' : 'Confirm service area',
        };
      }

      function callAngle() {
        const pains = state.answers.pains;
        const jobs = state.answers.jobs;
        const opening = [];
        if (pains.includes('Too much manual labor')) opening.push('reduce manual labor');
        if (pains.includes('Losing weekends or work hours')) opening.push('give back time');
        if (pains.includes('Current tractor is too small')) opening.push('solve the current capacity gap');
        if (pains.includes('Current equipment is unreliable')) opening.push('improve uptime and support');
        if (pains.includes('Confused by tractor and attachment choices') || pains.includes('First tractor and unsure where to start')) opening.push('make the package decision simple');
        const goal = opening.length ? opening.slice(0, 2).join(' and ') : 'connect the tractor class to the stated work';
        const entryLead = state.entryContext.source
          ? `Acknowledge that the lead entered from: ${entryContextSummary()}. `
          : '';
        const adjacentDirection = state.derived.adjacentClass
          ? ` If duty cycle, implement size, transport, and verified lift geometry justify moving up, also compare ${state.derived.adjacentModels}; do not treat it as the primary from job count alone.`
          : '';
        return `${entryLead}Lead with how the ${inventoryClasses[state.derived.tractorClass].label} and ${state.derived.attachmentDirection} can ${goal}. Reconfirm every selected job: ${jobs.join(', ') || 'not specified'}.${adjacentDirection}`;
      }

      function entryContextSummary() {
        const entry = state.entryContext;
        if (entry.source === 'inventory_card') {
          const classLabel = entry.tractorClass ? inventoryClasses[entry.tractorClass].label : 'tractor class';
          return `Inventory interest: ${entry.model || 'model not captured'} — ${classLabel}`;
        }
        if (entry.source === 'job_match') {
          const jobLabel = entryJobLabels[entry.landingJob] || 'job selection not captured';
          const classLabel = entry.tractorClass ? inventoryClasses[entry.tractorClass].label : 'class not captured';
          return `Landing job selection: ${jobLabel} — suggested ${classLabel}`;
        }
        return 'Direct quiz visit — no landing-page selection captured';
      }

      function renderEntryRibbon() {
        const ribbon = document.getElementById('entryRibbon');
        const entry = state.entryContext;
        let prefix = '';
        let emphasis = '';
        let suffix = '';
        if (entry.source === 'inventory_card' && entry.model) {
          prefix = 'Checking fit for the ';
          emphasis = entry.model;
          suffix = ' you were viewing.';
        } else if (entry.source === 'job_match' && entry.landingJob) {
          prefix = 'Confirming your match for: ';
          emphasis = entryJobLabels[entry.landingJob];
          suffix = '.';
        }
        if (!emphasis) {
          ribbon.hidden = true;
          ribbon.replaceChildren();
          return;
        }
        const strong = document.createElement('strong');
        strong.textContent = emphasis;
        ribbon.replaceChildren(document.createTextNode(prefix), strong, document.createTextNode(suffix));
        ribbon.hidden = false;
      }

      function resultReason() {
        const a = state.answers;
        const match = inventoryClasses[state.derived.tractorClass];
        const topJobs = a.jobs.slice(0, 3);
        const remainingJobs = a.jobs.length - topJobs.length;
        const jobSummary = `${topJobs.join(', ')}${remainingJobs > 0 ? `, and ${remainingJobs} more` : ''}`;
        const classCapability = {
          small: 'This is the lightest starting class represented in the current lineup.',
          medium: 'This class adds capacity over the small-property group without moving straight to the larger compact lineup.',
          heavy: 'This is the first larger-capacity group represented across several current configurations.',
          commercial: 'This is the highest-capacity class represented in the current prototype inventory.'
        }[state.derived.tractorClass];
        return `You told us: ${a.acreage} in ${a.state}; ${jobSummary}; heaviest load: ${a.load}. That complete workload is why we would start at a ${match.label}. ${classCapability}`;
      }

      function renderJobEcho(listId, summaryId) {
        const list = document.getElementById(listId);
        const summary = document.getElementById(summaryId);
        list.replaceChildren(...state.answers.jobs.map(job => {
          const item = document.createElement('li');
          item.textContent = job;
          return item;
        }));
        summary.textContent = `All ${state.answers.jobs.length} jobs used in this match`;
      }

      function renderAdjacentRecommendation(containerId, classId, reasonId, { includeModels = false } = {}) {
        const container = document.getElementById(containerId);
        const classElement = document.getElementById(classId);
        const reasonElement = document.getElementById(reasonId);
        const adjacentClass = state.derived.adjacentClass;
        if (!adjacentClass) {
          container.hidden = true;
          classElement.textContent = '';
          reasonElement.textContent = '';
          return;
        }
        const adjacent = inventoryClasses[adjacentClass];
        classElement.textContent = includeModels ? `${state.derived.adjacentModels} · ${adjacent.label}` : adjacent.label;
        reasonElement.textContent = state.derived.adjacentReason;
        container.hidden = false;
      }

      function scoreBreakdownSummary() {
        const breakdown = state.derived.scoreBreakdown;
        return [
          `acreage ${breakdown.acreage}`,
          `terrain ${breakdown.terrain}`,
          `jobs ${breakdown.jobsApplied} of ${breakdown.jobsRaw} applied`,
          `load ${breakdown.load}`,
          `profile ${breakdown.profile}`,
          `output ${breakdown.operator}`,
          `total ${breakdown.total}`,
          `load floor: ${inventoryClasses[breakdown.loadFloor].label}`,
          `commercial gate: ${breakdown.commercialGate ? 'met' : 'not met'}`
        ].join('; ');
      }

      function preferredChannel() {
        return {
          'Text me first': 'text message',
          'Call me first': 'phone call',
          'Email me first': 'email',
          'No preference': 'message'
        }[state.answers.contact.preferredMethod] || 'message';
      }

      function nextStepMessage() {
        const a = state.answers;
        const channel = preferredChannel();
        const firstName = a.contact.firstName || 'there';
        if (['As soon as the right package is available', 'Within 30 days'].includes(a.timeline)) {
          // CLAIM: verify SLA before production.
          return {
            priority: `Expect a ${channel} from a real person at Tractors For U within 24 hours.`,
            confirmation: `Done — ${firstName}, your match is organized for our team. We’ll start with your preferred ${channel}.`,
            heading: 'Your verification is next'
          };
        }
        if (a.timeline === 'Researching for later') {
          return {
            priority: `We’ll follow up once by ${channel}, then leave you to research until you are ready.`,
            confirmation: `${firstName}, your plan is ready for the team. We’ll follow up once, then leave you to research.`,
            heading: 'Research at your pace'
          };
        }
        return {
          priority: `We’ll use a ${channel} to confirm the class, attachments, and timing that fit your plan.`,
          confirmation: `${firstName}, your match is organized. We’ll use your preferred ${channel} to help when the timing is useful.`,
          heading: 'A useful follow-up, on your timing'
        };
      }

      function renderResultPreview({ track = true } = {}) {
        calculateRecommendation();
        const match = inventoryClasses[state.derived.tractorClass];
        document.getElementById('previewClass').textContent = match.label;
        document.getElementById('previewReason').textContent = resultReason();
        renderJobEcho('previewJobs', 'previewJobsSummary');
        document.getElementById('previewPrice').textContent = match.price;
        renderAdjacentRecommendation('previewAdjacent', 'previewAdjacentClass', 'previewAdjacentReason');
        if (track && !previewTracked) {
          trackEvent('tfu_result_preview', {
            tractor_class: state.derived.tractorClass,
            ...(state.derived.adjacentClass ? { adjacent_class: state.derived.adjacentClass } : {}),
            profile: state.answers.profile,
            job_count: state.answers.jobs.length,
            jobs: [...state.answers.jobs],
            timeline: state.answers.timeline
          });
          previewTracked = true;
          saveSession();
        }
      }

      function renderEntryAcknowledgment() {
        const element = document.getElementById('resultEntryAcknowledgment');
        const entryClass = state.entryContext.tractorClass;
        const resultClass = state.derived.tractorClass;
        if (!entryClass || entryClass === resultClass) {
          element.hidden = true;
          element.textContent = '';
          return;
        }
        const classes = ['small', 'medium', 'heavy', 'commercial'];
        const direction = classes.indexOf(resultClass) > classes.indexOf(entryClass) ? 'up' : 'down';
        element.textContent = `You started from the ${inventoryClasses[entryClass].label}. Your answers point one class ${direction}—your specialist will walk through both.`;
        element.hidden = false;
      }

      function renderResults({ track = true } = {}) {
        calculateRecommendation();
        const match = inventoryClasses[state.derived.tractorClass];
        const next = nextStepMessage();
        document.getElementById('resultClass').textContent = match.label;
        document.getElementById('resultReason').textContent = resultReason();
        renderJobEcho('resultJobs', 'resultJobsSummary');
        document.getElementById('resultPrice').textContent = match.price;
        document.getElementById('resultModels').textContent = match.models;
        document.getElementById('resultAttachments').textContent = state.derived.attachmentDirection;
        document.getElementById('resultPriority').textContent = next.priority;
        renderAdjacentRecommendation('resultAdjacent', 'resultAdjacentClass', 'resultAdjacentReason', { includeModels: true });
        document.getElementById('resultTier').textContent = `${state.answers.profile} match`;
        document.getElementById('resultConfirmation').textContent = next.confirmation;
        document.getElementById('nextStepHeading').textContent = next.heading;
        document.getElementById('nextStepCopy').textContent = next.priority;
        renderEntryAcknowledgment();
        const image = document.getElementById('resultImage');
        image.src = match.image;
        image.alt = `${match.label} example from current Tractors For U listings`;

        const brief = [
          ['Lead priority', `${state.derived.leadPriority} (score ${state.derived.leadScore})`],
          ['Landing-page intent', entryContextSummary()],
          ['Starting tractor direction', `${match.label}; check ${match.models}`],
          ['Adjacent class to verify', state.derived.adjacentClass ? `${inventoryClasses[state.derived.adjacentClass].label}; check ${state.derived.adjacentModels}` : 'Not indicated'],
          ['Scoring breakdown', scoreBreakdownSummary()],
          ['Buyer and property', `${state.answers.profile}; ${state.answers.acreage}; ${state.answers.state}`],
          ['Terrain / access', state.answers.terrain.join(', ')],
          ['All selected jobs', state.answers.jobs.join(', ')],
          ['Pain points', state.answers.pains.join(', ')],
          ['Heaviest expected load', state.answers.load],
          ['Operator priorities', state.answers.operatorPriorities.join(', ')],
          ['Attachment direction', state.derived.attachmentDirection],
          ['Purchase readiness', `${state.answers.timeline}; ${state.answers.purchasePath}; trade-in: ${state.answers.tradeIn}`],
          ['Contact preference', state.answers.contact.preferredMethod],
          ['Opening call angle', callAngle()],
          ['Qualification flags', [state.derived.serviceAreaFlag, ...state.derived.qualificationFlags].join('; ')],
          ['Additional notes', state.answers.notes || 'None supplied']
        ];

        const briefGrid = document.getElementById('briefGrid');
        if (briefGrid) briefGrid.innerHTML = brief.map(([label, content], index) =>
          `<div class="brief-item ${index >= 4 ? 'wide' : ''}"><span>${escapeHtml(label)}</span><strong>${escapeHtml(content)}</strong></div>`
        ).join('');

        const payload = {
          ...state,
          derived: { ...state.derived, openingCallAngle: callAngle() },
          submittedAt: new Date().toISOString()
        };
        const payloadOutput = document.getElementById('payloadOutput');
        if (payloadOutput) payloadOutput.textContent = JSON.stringify(payload, null, 2);

        if (track) {
          trackEvent('tfu_quiz_result', {
            tractor_class: state.derived.tractorClass,
            ...(state.derived.adjacentClass ? { adjacent_class: state.derived.adjacentClass } : {}),
            lead_priority: state.derived.leadPriority.split(' — ')[0].toLowerCase(),
            timeline: state.answers.timeline,
            profile: state.answers.profile,
            job_count: state.answers.jobs.length,
            jobs: [...state.answers.jobs],
            attachment_count: state.answers.attachmentsRequested.length,
            service_area_status: state.derived.serviceAreaFlag
          });
          trackEvent('tfu_lead_ready', {
            tractor_class: state.derived.tractorClass,
            lead_priority: state.derived.leadPriority.split(' — ')[0].toLowerCase(),
            timeline: state.answers.timeline,
            purchase_path: state.answers.purchasePath,
            has_trade_in: state.answers.tradeIn !== 'No'
          });
        }
      }

      function escapeHtml(input) {
        return String(input).replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
      }

      form.addEventListener('click', event => {
        const next = event.target.closest('[data-next]');
        const back = event.target.closest('[data-back]');
        if (next) {
          document.getElementById('resumeNotice').hidden = true;
          if (!validateStep(currentStep)) return;
          syncAnswers();
          if (!quizStarted) {
            quizStarted = true;
            trackEvent('tfu_quiz_start', { start_step: 'profile' });
          }
          trackEvent('tfu_quiz_step_complete', {
            step_number: currentStep,
            step_key: ['start', 'profile', 'property', 'jobs', 'load', 'priorities', 'attachments', 'readiness', 'result_preview', 'contact'][currentStep],
            ...(currentStep === 3 ? { job_count: state.answers.jobs.length, jobs: [...state.answers.jobs] } : {})
          });
          if (currentStep === 7) renderResultPreview();
          showStep(currentStep + 1);
        }
        if (back && currentStep > 1) {
          document.getElementById('resumeNotice').hidden = true;
          showStep(currentStep - 1, 'back');
        }
      });

      form.addEventListener('change', event => {
        const step = event.target.closest('.step');
        if (event.target.name === 'pains' && event.target.checked) {
          if (event.target.id === 'pain-none') {
            form.querySelectorAll('[name="pains"]:not(#pain-none)').forEach(input => { input.checked = false; });
          } else {
            const planningAhead = document.getElementById('pain-none');
            if (planningAhead) planningAhead.checked = false;
          }
        }
        syncAnswers();
        updateSelectionStatuses();
        const error = step?.querySelector('[data-error]');
        if (error && !error.hidden) validateStep(currentStep, { focus: false });
        saveSession();
      });

      form.addEventListener('input', event => {
        const step = event.target.closest('.step');
        const error = step?.querySelector('[data-error]');
        if (error && !error.hidden) validateStep(currentStep, { focus: false });
        saveSession();
      });

      function buildShopifyContactBody() {
        calculateRecommendation();
        return [
          'TRACTORS FOR U QUALIFICATION QUIZ',
          'Quiz version: ' + state.quizVersion,
          'Entry context: ' + entryContextSummary(),
          'Starting tractor direction: ' + inventoryClasses[state.derived.tractorClass].label,
          'Current models to verify: ' + state.derived.currentModels,
          'Adjacent class to verify: ' + (state.derived.adjacentClass ? inventoryClasses[state.derived.adjacentClass].label + ' / ' + state.derived.adjacentModels : 'Not indicated'),
          'Buyer profile: ' + state.answers.profile,
          'Acreage: ' + state.answers.acreage,
          'State: ' + state.answers.state,
          'Terrain / access: ' + state.answers.terrain.join(', '),
          'ALL SELECTED JOBS: ' + state.answers.jobs.join(', '),
          'Heaviest expected load: ' + state.answers.load,
          'Pain points: ' + state.answers.pains.join(', '),
          'Operator priorities: ' + state.answers.operatorPriorities.join(', '),
          'Attachment interests: ' + state.answers.attachmentsRequested.join(', '),
          'Attachment direction: ' + state.derived.attachmentDirection,
          'Timeline: ' + state.answers.timeline,
          'Purchase path: ' + state.answers.purchasePath,
          'Trade-in: ' + state.answers.tradeIn,
          'Preferred contact: ' + state.answers.contact.preferredMethod,
          'Lead priority: ' + state.derived.leadPriority,
          'Scoring breakdown: ' + scoreBreakdownSummary(),
          'Opening call angle: ' + callAngle(),
          'Qualification flags: ' + [state.derived.serviceAreaFlag, ...state.derived.qualificationFlags].join('; '),
          'Additional notes: ' + (state.answers.notes || 'None supplied')
        ].join('\n');
      }

      function populateShopifyContactFields() {
        document.getElementById('shopifyContactName').value = [state.answers.contact.firstName, state.answers.contact.lastName].filter(Boolean).join(' ');
        document.getElementById('shopifyContactEmail').value = state.answers.contact.email;
        document.getElementById('shopifyContactPhone').value = state.answers.contact.phone;
        document.getElementById('shopifyContactBody').value = buildShopifyContactBody();
      }

      form.addEventListener('submit', event => {
        if (!validateStep(9)) {
          event.preventDefault();
          return;
        }
        syncAnswers();
        populateShopifyContactFields();
        trackEvent('tfu_quiz_step_complete', {
          step_number: 9,
          step_key: 'contact'
        });
        saveSession();
      });

      document.getElementById('restartQuiz').addEventListener('click', () => {
        form.reset();
        refreshCustomSelects();
        state.answers = {};
        state.derived = {};
        quizStarted = false;
        previewTracked = false;
        document.getElementById('resumeNotice').hidden = true;
        clearSession();
        trackEvent('tfu_quiz_restart');
        showStep(1, 'back', { replaceHistory: true, persist: false });
      });

      form.querySelectorAll('[data-error]').forEach((error, index) => {
        error.id = `step-error-${index + 1}`;
        error.setAttribute('role', 'alert');
      });
      form.querySelectorAll('[data-field-error]').forEach(error => error.setAttribute('role', 'alert'));

      window.addEventListener('popstate', event => {
        const step = Number(event.state?.tfuQuizStep);
        if (!step) return;
        handlingPopState = true;
        if (step === 8) renderResultPreview({ track: false });
        if (step === 10) renderResults({ track: false });
        showStep(step, step < currentStep ? 'back' : 'forward', { history: false });
        handlingPopState = false;
      });

      hydrateChoiceIcons();
      initCustomSelects();
      renderEntryRibbon();
      trackEvent('tfu_quiz_view', { page_type: 'separate_quiz' });
      const restoredSession = restoreSession();
      const submissionState = document.getElementById('submissionState');
      const submittedSuccessfully = submissionState?.dataset.success === 'true';
      const submissionHasErrors = submissionState?.dataset.hasErrors === 'true';
      refreshCustomSelects();
      updateSelectionStatuses();
      if (submittedSuccessfully && restoredSession) {
        renderResults({ track: false });
        showStep(10, 'forward', { replaceHistory: true, persist: false });
        trackEvent('tfu_quiz_result', {
          tractor_class: state.derived.tractorClass,
          ...(state.derived.adjacentClass ? { adjacent_class: state.derived.adjacentClass } : {}),
          lead_priority: state.derived.leadPriority.split(' — ')[0].toLowerCase(),
          timeline: state.answers.timeline,
          profile: state.answers.profile,
          job_count: state.answers.jobs.length,
          jobs: [...state.answers.jobs],
          attachment_count: state.answers.attachmentsRequested.length,
          service_area_status: state.derived.serviceAreaFlag
        });
        trackEvent('tfu_lead_ready', {
          tractor_class: state.derived.tractorClass,
          lead_priority: state.derived.leadPriority.split(' — ')[0].toLowerCase(),
          timeline: state.answers.timeline,
          purchase_path: state.answers.purchasePath,
          has_trade_in: state.answers.tradeIn !== 'No'
        });
      } else if (submissionHasErrors && restoredSession) {
        showStep(9, 'back', { replaceHistory: true, persist: false });
      } else if (restoredSession) {
        document.getElementById('resumeNotice').hidden = false;
        if (restoredSession.step === 8) renderResultPreview({ track: false });
        if (restoredSession.step === 10) renderResults({ track: false });
        showStep(restoredSession.step, 'back', { replaceHistory: true, persist: false });
      } else {
        showStep(1, 'back', { replaceHistory: true, persist: false });
      }
    })();
  